<template>
  <v-autocomplete
    :items="city_areas"
    item-text="name"
    @change="handleSelect"
    :loading="loading"
    :value="city_area"
    v-bind="$props"
    :disabled="!city"
    :hint="
      !city ? capitalize($tc('model.address_message_first_pick_a_city')) : ''
    "
    persistent-hint
    return-object
  ></v-autocomplete>
</template>

<script>
import { getCityAreas } from "../../services/locals";

export default {
  name: "select-city-area",
  props: {
    city_area: Object,
    city: Object,
    label: String,
    clearable: Boolean,
    "error-messages": Array,
    name: String,
    autocomplete: String,
  },
  model: {
    prop: "city_area",
    event: "change",
  },
  data: () => ({
    city_areas: [],
    loading: false,
  }),
  methods: {
    capitalize: function (s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    async getCityAreas(city) {
      this.loading = true;
      this.city_areas = await getCityAreas(city.id);
      this.loading = false;
    },
    handleSelect(value) {
      this.$emit("change", value);
    },
  },
  created() {
    if (!this.city) {
      this.city_areas = [];
    } else {
      this.getCityAreas(this.city);
    }
  },
  watch: {
    city: function (value, old_value) {
      if (!value) {
        this.city_areas = [];
      } else {
        this.getCityAreas(value);
      }

      if (old_value) {
        this.$emit("change", null);
      }
    },
  },
};
</script>